import { ProcedureName98 } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: "氏名",
  },
  {
    headTitle: "操作種類",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "lineTitle",
    lineTitle: "依頼された作業",
  },
  {
    title: "代行内容",
    keyword: "formerTaskType",
    type: "text",
  },
  {
    title: "対象施設",
    keyword: "facilityName",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "staffName",
    type: "text",
    showLine: false,
  },
  {
    title: "タイトル",
    keyword: "title",
    type: "text",
  },
  {
    title: "本文",
    keyword: "text",
    type: "nodeInLine",
  },
];

const businessTypeList = {
  [ProcedureName98["加入届"]]: "JOB-23",
  [ProcedureName98["本俸/調整額の更新"]]: "JOB-26",
  [ProcedureName98["従業状況の更新"]]: "JOB-25",
  [ProcedureName98["配置換え（対象外異動含む）"]]: "JOB-27",
  [ProcedureName98["退職届"]]: "JOB-32",
  [ProcedureName98["退職届（施設単位）"]]: "JOB-32",
} as { [key: string]: string };

export { headTitleList, fakeTableList, businessTypeList };
